'use client';

import CloseIcon from '@/icons/close.svg';
import { usePathname } from 'next/navigation';
import { PropsWithChildren, ReactNode, useEffect, useId, useRef } from 'react';

type Props = {
  buttonText: ReactNode;
  buttonClass: string;
  dialogClass: string;
  toggleOpen?: () => void;
};

function DialogButton(props: PropsWithChildren<Props>) {
  const { buttonText, buttonClass, dialogClass, children, toggleOpen } = props;
  const dialogRef = useRef<HTMLDialogElement>(null);
  const dialogID = useId();
  const pathname = usePathname();

  useEffect(() => {
    // close the modal whenever the route (pathname) changes
    dialogRef.current?.close();
  }, [pathname]);
  return (
    <>
      <button
        className={`dialog-button ${buttonClass}`}
        onClick={() => {
          dialogRef.current?.showModal();
          if (toggleOpen) toggleOpen();
        }}
      >
        {buttonText}
      </button>
      <dialog
        id={`${dialogClass}-${dialogID}`}
        ref={dialogRef}
        className={`dialog ${dialogClass}`}
        closedby='any'
        aria-modal='true'
      >
        <div className={`dialog__container-close ${dialogClass}__container-close`}>
          <button
            aria-controls={`${dialogClass}-${dialogID}`}
            className={`dialog__close ${dialogClass}__close`}
            aria-label='Dialog schließen'
            onClick={() => dialogRef.current?.close()}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={`dialog__content ${dialogClass}__content`}>{children}</div>
      </dialog>
    </>
  );
}

export default DialogButton;
